/* eslint-disable no-shadow */
import mitt from 'mitt'

export enum EventName {
  'SET_TEXT' = 'SET_TEXT',
}

export const emitter = mitt()
